import { Component, OnInit } from '@angular/core';

import { EncryptService } from "../../../../_shared/encrypt";

@Component({
  selector: 'app-dots',
  templateUrl: './dots.component.html',
  providers: []
})
export class DotsComponent implements OnInit {

  // declaraciones
  public user = null;
  
  constructor(
    private encryptService: EncryptService

  ) {
    

  }

  ngOnInit() {
    this.user = JSON.parse(this.encryptService.decryptData(localStorage.getItem('tp_dataUserComplete')));

  }


}
